import request from '@/utils/request'
const apiPath = '/tech/technicianQuota'

const technicianQuotaApi = {
  // 获取指标总配额
  getServiceStatistics(query){
    return request.get(`${apiPath}/tee/getTotalQuota`, { params: query })
  },
  // 新增【技术员（老师）配额】
  createQuota(data){
    return request.post(`${apiPath}`,data)
  },
  updateQuota(data){
    return request.put(`${apiPath}`, data)
  },
  // 导出
  exportExcels(query) {
    return request.get(apiPath + '/export', { params: query })
  },
}
export default technicianQuotaApi
